// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1ROmR","ranges":"BmiRanges_ranges__MIisx"};